import { Box, Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import api from "../../../common/utils/api";
import { enqueueSnackbar } from "notistack";
import { Warning } from "@mui/icons-material";

export default function AccessIssue(props) {
  const [loading, setLoading] = useState(false);
  const handleFix = () => {
    setLoading(true);
    api
      .post(`/portal/access-validation/${props.projectId}/${props.endpoint}`)
      .then((resp) => {
        enqueueSnackbar("Issue fixed", { variant: "success" });
        if (props.onFix) {
          props.onFix();
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.response?.data?.error || err.message || "Error fixing issue");
      })
      .finally((_) => {
        setLoading(false);
      });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        border: "1px solid red",

        p: 1,
        alignItems: "center",
      }}
    >
      <Box>
        <Warning color="error" /> {props.description}
      </Box>
      {props.endpoint && (
        <Button onClick={handleFix} variant="contained" color="primary" disabled={loading} size="small">
          {loading ? <CircularProgress size="1.4rem" /> : <>Fix</>}
        </Button>
      )}
    </Box>
  );
}
